export default __webpack_public_path__ + "static/media/taipei-american-school.72fee768.svg";